module.exports = __webpack_public_path__ + "a8680ee4a60bc03270cb85165fbd2878.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
// module id = 17
// module chunks = 0